/**
 * Created by Kaku.Guo on 2018/11/5.
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Message } from '../index';

const LoadIndicator = ({ isLauncher }) => {
    return (
        <div className="load-indicator">
            <div className="container">
                <div className="row">
                    <div className={classNames('logo pulse', { 'is-launcher': isLauncher })}>
                        <div id="logo" />
                    </div>

                    <div className="loading-container">
                        <div className="wrapper-left">
                            <div className="loader">
                                <div />
                                <div />
                                <div />
                                <div />
                                <div />
                                <div />
                                <div />
                                <div />
                                <div />
                                <div />
                            </div>
                        </div>
                        <div className="wrapper-right">
                            <div className="loader">
                                <div />
                                <div />
                                <div />
                                <div />
                                <div />
                                <div />
                                <div />
                                <div />
                                <div />
                                <div />
                            </div>
                        </div>
                    </div>
                    <h6 className="load-text">
                        <Message code="messages.com.epicgames.plugin.store.common.loading" />
                    </h6>
                </div>
            </div>
        </div>
    );
};

LoadIndicator.propTypes = {
    isLauncher: PropTypes.bool
};

export default LoadIndicator;